import Text from '@service-victoria/component-library/components/Text';
import React from 'react';
import { TextBodyWithInlineLink } from 'steps/styled';

export default function FAQs() {
  return (
    <>
      <Text.Body>
        <TextBodyWithInlineLink>
          For more info call the{' '}
          <Text.Link
            href='https://business.vic.gov.au/contact-us'
            value='Business Victoria hotline'
          />{' '}
          on 13 22 15. It’s open 8am to 6pm 7 days a week.
        </TextBodyWithInlineLink>
      </Text.Body>
    </>
  );
}

// For more info call the Business Victoria hotline on 13 22 15. It’s open 8am to 6pm 7 days a week.
